import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import { useState } from 'react';

import { ReactNativeWrapper } from './microfrontend/wrappers/ReactNativeWrapper';
import { ReactWrapper } from './microfrontend/wrappers/ReactWrapper';

enum WrapperTypeEnum {
  REACT = 'react',
  REACT_NATIVE = 'reactNative',
}

// По умолчанию в сборку попадает вариант для React Native, а веб интегрирует только сам компонент mf-app
export const App = () => {
  const [wrapperType] = useState<WrapperTypeEnum>(WrapperTypeEnum.REACT_NATIVE);

  return (
    <>
      {wrapperType === WrapperTypeEnum.REACT && <ReactWrapper />}
      {wrapperType === WrapperTypeEnum.REACT_NATIVE && <ReactNativeWrapper />}
    </>
  );
};
